import { TRaidKillCountsByDifficulty } from '../sharedTypes';

export const CURRENT_TIER_CROSSSERVER_RAID_KILLCOUNT: TRaidKillCountsByDifficulty = {
  normal10: 7,
  heroic10: 7,
  normal25: 13,
  heroic25: 13
};

export const CURRENT_TIER_RAID_KILLCOUNT: TRaidKillCountsByDifficulty = {
  normal10: 7,
  heroic10: 7,
  normal25: 13,
  heroic25: 13
};


export const PREVIOUS_TIER_RAID_KILLCOUNT: TRaidKillCountsByDifficulty = {
  normal10: 7,
  heroic10: 7,
  normal25: 13,
  heroic25: 13
};

export const PREVIOUS_XPAC_RAID_KILLCOUNT: TRaidKillCountsByDifficulty = {
  normal10: 7,
  heroic10: 7,
  normal25: 13,
  heroic25: 13
};
